(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9230],{

/***/ 79230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NextOpenDate; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94148);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70457);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12284);
/* harmony import */ var _helpers_websites_isStoreOpenNow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34490);
/* harmony import */ var lodash_isObject__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13218);
/* harmony import */ var lodash_isObject__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isObject__WEBPACK_IMPORTED_MODULE_5__);







function NextOpenDate(props) {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("website", {
        keyPrefix: "order.nextOpenDate"
    }).t;
    if (!props.store) return null;
    var propsItsOpenNow = props.store.schedule && props.store.schedule.itsOpenNow;
    var itsOpenNow = (0,_helpers_websites_isStoreOpenNow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props.store);
    var closedMessage = !!propsItsOpenNow && lodash_isObject__WEBPACK_IMPORTED_MODULE_5___default()(propsItsOpenNow) ? propsItsOpenNow.closedMessage : null;
    if (itsOpenNow) return null;
    var nextDate = props.store.nextAvailableDate;
    var schedulingOrdersDays = props.store.schedulingOrdersDays;
    var className = [
        (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().container),
        props.className
    ].join(" ");
    var schedulingClassName = [
        (_styles_module_css__WEBPACK_IMPORTED_MODULE_6___default().scheduling),
        props.className
    ].join(" ");
    if (closedMessage) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: schedulingClassName,
            children: closedMessage
        });
    }
    if (!nextDate) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: t("labelClosedNow")
        });
    }
    var date = (0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(nextDate);
    if (date.isSame((0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), "day")) {
        if (schedulingOrdersDays) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: schedulingClassName,
                children: t("labelScheduleOrderAfter", {
                    date: date.format("HH:mm")
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: t("labelClosedUntil", {
                date: date.format("HH:mm")
            })
        });
    }
    if (date.isSame((0,_helpers_dayjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().add(1, "day"), "day")) {
        if (schedulingOrdersDays >= 2) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: schedulingClassName,
                children: t("labelScheduleOrderTomorrow")
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: className,
            children: t("labelClosedUntilTomorrow", {
                date: date.format("HH:mm")
            })
        });
    }
    if (schedulingOrdersDays >= 3) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: schedulingClassName,
            children: t("labelScheduleOrderFrom", {
                date: date.format("dddd D [de] MMMM")
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: t("labelClosedUntilDate", {
            date: date.format("LL"),
            hour: date.format("HH:mm")
        })
    });
};


/***/ }),

/***/ 94148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1p4i0Q6FHN2JmlK1-Aq9gW","scheduling":"z5vfYbOpyPAIVionHNmzq _1p4i0Q6FHN2JmlK1-Aq9gW"};

/***/ })

}]);